import { configCategory } from "@pub/config";
import { Ads } from "@sphtech/dmg-design-system";
import cx from "classnames";
import { ReactNode } from "react";

import styles from "../category.module.css";
import SubAnchorVideo from "../SubAnchorVideo";
import { CategoryLayoutElementProps } from "../types/types";

export default function CategoryVideoGalleryBlock({
  data,
}: CategoryLayoutElementProps): ReactNode {
  const hasVideoGallery = !!(
    configCategory.videoGalleryLandscape?.display &&
    data.videoGallery &&
    data.videoGallery.teasers.length > 0
  );
  const mobileAdBeforeVideoGallery = !!data.uniqSectionName && hasVideoGallery;

  if (!hasVideoGallery) {
    return null;
  }

  return (
    <section className={cx(styles.bodyContainer, styles.videoGallerySection)}>
      <div className={styles.videoGalleryContainer}>
        <div className={styles.videoGalleryWrapper}>
          <SubAnchorVideo videoGallery={data.videoGallery} />
          {mobileAdBeforeVideoGallery && (
            <div className={styles.mobileAdvertisement}>
              <Ads.AdsSideBarMobile />
            </div>
          )}
        </div>

        <div className={styles.sidebar}>
          {mobileAdBeforeVideoGallery ? (
            <Ads.AdsSideBarDesktop />
          ) : (
            <Ads.AdsSideBar />
          )}
        </div>
      </div>
    </section>
  );
}
